module.exports = __webpack_public_path__ + "img/sent-mail-img.36985455.png";